jQuery(document).ready(function($) {
    // Add or remove product from favorites
    $(document).on('click', '.add-to-favorites', function(e) {
        e.preventDefault();
        var button = $(this);
        var productId = button.data('product-id');
        var isFavorite = button.hasClass('remove');
        
        $.ajax({
            url: ajax.ajax.url,
            type: 'POST',
            data: {
                action: 'add_to_favorites',
                product_id: productId,
                is_favorite: isFavorite,
                //nonce: ajax_object.nonce
            },
            beforeSend: function() {
                button.prop('disabled', true);
                button.addClass('loading');
            },
            success: function(response) {
                if (response.success) {
                    // Update button text and class
                    button.toggleClass('add remove');
                    button.find('span').text(isFavorite ? 'Add to Favorites' : 'Remove from Favorites');
                    button.toggleClass('favorite');
                }
            },
            complete: function() {
                button.prop('disabled', false);
                button.removeClass('loading');
            }
        });
    });
});



// WEBPACK FOOTER //
// ./resources/assets/js/partials/favourites.js